import { TODAY_STR } from "../data/mockBookings";

export const fmtINR = (n) => "₹ " + (n || 0).toLocaleString("en-IN");

export const fmtDate = (d, opts = {}) => {
  if (!d) return "—";
  const dt = new Date(d);
  const def = { weekday: "short", day: "2-digit", month: "short", year: "numeric" };
  return dt.toLocaleDateString("en-IN", { ...def, ...opts });
};

export const fmtDateShort = (d) => {
  if (!d) return "—";
  const dt = new Date(d);
  return dt.toLocaleDateString("en-IN", { day: "2-digit", month: "short" });
};

export const fmtDateTime = (d) => {
  if (!d) return "—";
  const dt = new Date(d);
  return (
    dt.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) +
    " · " +
    dt.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true })
  );
};

export const daysUntil = (d) => {
  const dt = new Date(d);
  const diff = dt - new Date(TODAY_STR);
  return Math.round(diff / (1000 * 60 * 60 * 24));
};

export const relativeDayLabel = (d) => {
  const n = daysUntil(d);
  if (n === 0) return "Today";
  if (n === 1) return "Tomorrow";
  if (n === -1) return "Yesterday";
  if (n > 1) return "in " + n + "d";
  return Math.abs(n) + "d ago";
};
